import "../../styles/contact-us.css";
import BgImage from "../../images/contact-us/bg-image.png";
import Header from "../../components/header";
import ContactCta from "./contactCta";
import ContactFooter from "./contactFooter";

function ContactUs() {
  return (
    <div className="contact-us">
      <Header />
      <img src={BgImage} className="hero-bg" alt="bg" />
      <ContactCta />
      <ContactFooter />
    </div>
  );
}

export default ContactUs;
